import script from "./CJoinedTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./CJoinedTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./CJoinedTemplate.vue?vue&type=style&index=0&id=99b23656&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99b23656"]])

export default __exports__